import { ConversionUtils, DeviceTypeIds } from '@ncss/models';
import { Device, DeviceFamily, IDeviceType, DeviceTypeHelper, RFMeterRead, RR4Read } from '@ncss/models/dist/v3';

export function isManualReadDevice(device?: Device): device is Device & { id: number } {
  return (
    device instanceof Device &&
    !!device.id &&
    DeviceTypeHelper.GetFamilyBySerialNumber(device.id) === DeviceFamily.MANUAL_READER
  );
}

export function getMeterReadOnLCD(read: RFMeterRead) {
  const meterRead = read.meterRead();
  if (meterRead === null) {
    return '';
  }
  let str: string | undefined = undefined;
  if (read instanceof RR4Read) {
    const decimalPosition = read.lcdDecimalPositionEn ? read.lcdDecimalPosition : 1;
    str = (Math.floor(meterRead * Math.pow(10, decimalPosition)) / Math.pow(10, decimalPosition)).toFixed(
      decimalPosition
    );
  } else {
    str = meterRead.toString();
  }

  return str;
}

export function getRemoteReaderPort(deviceId: number) {
  if (DeviceTypeHelper.GetFamilyBySerialNumber(deviceId) === DeviceFamily.REMOTE_READER) {
    const base = ConversionUtils.GetBaseRRSerial(deviceId);
    return deviceId - base;
  }
  return undefined;
}

export function DeviceTypeToImgUrl(deviceType?: IDeviceType | null) {
  if (!deviceType) {
    return '/equipment/device-types/NoUnitDevice.png';
  }
  if (DeviceTypeHelper.GetIsEmbeddedTransceiver(deviceType.id)) {
    return `/equipment/device-types/${DeviceTypeIds.TR4_E}.png`;
  }
  if (DeviceTypeHelper.GetIsThirdParty(deviceType.id)) {
    return '/equipment/device-types/third-party.png';
  }
  return `/equipment/device-types/${deviceType.id}.png`;
}
